import * as player from "@/api/player.api";

const initialState = () => ({
  loading: false,
  auth: null,
  path: null,
  pos: 0,
  pos_update: null,
  donate: false,
  donateEmail: null,
  donateCurrency: null,
  donateOrg: null,
  donateButton: null,
  donateLoc: null,
  donateAmounts: [],
  pathSelf: null,
  chromecastEnabled: false
});

const state = initialState();

const mutations = {
  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  UPDATE_PATH(state, payload) {
    state.path = payload;
    state.pos_update = payload.pos_update;
    state.pathSelf = payload.self;
    state.donate = payload.donate;
    state.donateEmail = payload.donate_email;
    state.donateCurrency = payload.donate_currency;
    state.donateOrg = payload.donate_org;
    state.donateButton = payload.donate_button;
    state.donateLoc = payload.donate_loc;
    state.donateAmounts = payload.donate_amounts;
  },
  UPDATE_AUTH(state, payload) {
    state.auth = payload;
  },
  UPDATE_LOADING(state, payload) {
    state.loading = payload;
  },
  UPDATE_POS(state, payload) {
    state.pos = payload;
  },
  UPDATE_CHROMECAST_ENABLED(state, payload) {
    state.chromecastEnabled = payload;
  }
};

const actions = {
  async getPath({ dispatch, commit }, { path, ref }) {
    try {
      const response = await player.getPath(path, ref);
      commit("UPDATE_PATH", response.data);
    } catch (error) {
      if (error.response.status == 404) {
        dispatch("reset");
      }
    }

    commit("UPDATE_AUTH", null);
  },
  async getAuth({ commit, state }) {
    try {
      if (state.pos_update) {
        const response = await player.getAuth(state.pos_update);
        commit("UPDATE_AUTH", response.data);
        if (response.data.status) {
          commit("UPDATE_AUTH", response.data.status);
        } else {
          commit("UPDATE_AUTH", "INVALID");
        }
      } else {
        commit("UPDATE_AUTH", "VALID");
      }
    } catch (error) {
      //
    }
  },
  async setPos({ commit, state }, pos) {
    try {
      if (state.pos_update) {
        await player.setPos(state.pos_update, pos);
        commit("UPDATE_POS", pos);
      }
    } catch (error) {
      //
    }
  },
  reset({ commit }) {
    commit("RESET");
  }
};

const getters = {
  sourceURL: state => state.path.link_url + "json" + state.path.qstring,
  donateURL: state => state.pathSelf + "/ppd",
  donateCurrencies: state => Object.keys(state.donateAmounts)
};

const playerModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default playerModule;
